import { cn } from "~/lib/utils";

// // // //

/**
 * PageWrapper
 * Small component to consistently wrap the page content rendered inside SidebarLayout.props.children
 * @param props
 * @returns
 */
export function PageWrapper(props: {
    children: React.ReactNode;
    className?: string;
}) {
    return (
        <>
            <div className={cn(`mx-6`, props.className)}>{props.children}</div>
        </>
    );
}
